import React from 'react';
import AddressConfirmation from './AddressConfirmation/AddressConfirmation';
import styles from './MailingAddressConfirmation.module.scss';
import BreadCrumb from '@ds/elements/BreadCrumb/BreadCrumb';


const MailingAddressConfirmation: React.FC = ({
}) => {

  return (
    <div className={styles['mailing-address-confirmation']}>
        <BreadCrumb items={[{label: 'Home', url: '/home'}, {label: 'Mailing Address Confirmation', url: '/mailing-address-confirmation'}]}/>
        <div className={styles['mac-container']}>
          <AddressConfirmation/>
        </div>
    </div>
  );
};

export default MailingAddressConfirmation;